//使用总线进行组件间的跨级通信问题
const install = (Vue) =>{
  const Bus = new Vue({
    methods:{
      emit(event,...args){
        this.$on(event,args);
      },
      on(event,callback){
        this.$on(event,callback);
      },
      off(event,callback){
        this.$off(event,callback);
      }
    }
  })
  Vue.prototype.$bus = Bus
};
export default install



// WEBPACK FOOTER //
// ./src/utils/vue-bus.js